module.exports = __webpack_public_path__ + "static/media/find_a_mechanic.4ee7fe2e.png";